/**
 * Skipp header: per top-level menu item gradient; active tab look is CSS underline (no inline pill).
 */
(function () {
  var LINK_SEL = 'a[data-skipp-theme="1"]';

  function getHeaderWrap() {
    var sec = document.querySelector('.shopify-section.section-header');
    var w = null;
    if (sec) {
      w =
        sec.querySelector('.header-wrapper--skipp-nav-theme') ||
        sec.querySelector('.header-wrapper--skipp-desktop') ||
        sec.querySelector('.header-wrapper');
    }
    return (
      w ||
      document.querySelector('.header-wrapper--skipp-nav-theme') ||
      document.querySelector('.header-wrapper--skipp-desktop') ||
      document.querySelector('.header-wrapper')
    );
  }

  function clearActiveStyles(a) {
    a.style.removeProperty('background-color');
    a.style.removeProperty('color');
    a.style.removeProperty('padding');
    a.style.removeProperty('border-radius');
    a.style.removeProperty('box-shadow');
  }

  function applyTheme(el) {
    var wrap = getHeaderWrap();
    if (!wrap || !el.dataset.skippGTop) return;

    wrap.style.setProperty('--skipp-nav-grad-top', el.dataset.skippGTop);
    wrap.style.setProperty('--skipp-nav-grad-mid', el.dataset.skippGMid);
    wrap.style.setProperty('--skipp-nav-grad-bottom', el.dataset.skippGBottom);
    var stop = el.dataset.skippGStop || '32';
    if (stop.indexOf('%') === -1) stop = stop + '%';
    wrap.style.setProperty('--skipp-nav-grad-stop', stop);

    document.querySelectorAll(LINK_SEL).forEach(function (a) {
      a.classList.remove('active');
      a.removeAttribute('aria-current');
      clearActiveStyles(a);
    });
    el.classList.add('active');
    el.setAttribute('aria-current', 'page');
    /* Active appearance = CSS underline + theme colors (no filled pill via inline styles). */
  }

  function normalizePath(pathname) {
    if (!pathname || pathname === '') return '/';
    var s = pathname.replace(/\/+$/, '');
    return s === '' ? '/' : s;
  }

  /** mWeb: Shopify link.current is false on home and some nested URLs; match pathname + optional home handle. */
  function syncMobileNavFromUrl() {
    var nav = document.querySelector('.modern-header__mobile-nav-links--bar');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a.modern-header__mobile-nav-link'));
    if (!links.length) return;

    var path = normalizePath(window.location.pathname);
    var best = null;
    var bestLen = -1;

    links.forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      try {
        var u = new URL(href, window.location.origin);
        var lp = normalizePath(u.pathname);
        if (lp === '/') return;
        var matches =
          path === lp || (path !== '/' && path.indexOf(lp + '/') === 0);
        if (
          !matches &&
          lp.length > 1 &&
          path.length >= lp.length &&
          path.slice(-lp.length) === lp &&
          (path.length === lp.length || path.charAt(path.length - lp.length - 1) === '/')
        ) {
          matches = true;
        }
        if (matches && lp.length > bestLen) {
          bestLen = lp.length;
          best = a;
        }
      } catch (e) {}
    });

    var homeHandle = (nav.getAttribute('data-skipp-mweb-home-active') || '').trim().toLowerCase();
    if (!best && (path === '/' || path === '') && homeHandle) {
      for (var i = 0; i < links.length; i++) {
        var h = (links[i].getAttribute('data-nav-handle') || '').trim().toLowerCase();
        if (h === homeHandle) {
          best = links[i];
          break;
        }
      }
    }

    if (!best) return;

    links.forEach(function (s) {
      s.classList.remove('active');
      s.removeAttribute('aria-current');
    });
    best.classList.add('active');
    best.setAttribute('aria-current', 'page');
  }

  function bindMobileBar() {
    document.querySelectorAll('.modern-header__mobile-nav-links--bar .modern-header__mobile-nav-link').forEach(function (a) {
      if (a.dataset.skippMwebBound === '1') return;
      a.dataset.skippMwebBound = '1';
      a.addEventListener('click', function () {
        document
          .querySelectorAll('.modern-header__mobile-nav-links--bar .modern-header__mobile-nav-link')
          .forEach(function (s) {
            s.classList.remove('active');
            s.removeAttribute('aria-current');
          });
        this.classList.add('active');
        this.setAttribute('aria-current', 'page');
      });
    });
  }

  function init() {
    document.querySelectorAll(LINK_SEL).forEach(function (a) {
      if (a.dataset.skippBound === '1') return;
      a.dataset.skippBound = '1';
      a.addEventListener('click', function () {
        applyTheme(this);
      });
    });
    bindMobileBar();
    syncMobileNavFromUrl();
    var active = document.querySelector(LINK_SEL + '.active');
    if (active && active.dataset.skippGTop) {
      applyTheme(active);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', function () {
    syncMobileNavFromUrl();
  });
  document.addEventListener('shopify:section:load', init);
})();
